/**
 * The landing registry: every page `Hero` can render, and how a member reaches one.
 *
 * Names only. The component map lives in `-/components/connected/steps/Hero`, because
 * `UIService` has to answer "which page?" and importing the components here would put
 * every landing page behind a service that half the app already depends on.
 *
 * Three ways a page is chosen, in this order:
 *
 *   1. `stips` / `documents`, which are URL MODES rather than variants -- if the member
 *      is in stips mode nothing else gets a say.
 *   2. `?t=` on the URL. A production channel: marketing puts it in mailed PURLs, and it
 *      is also how anyone checks a variant against a real offer without editing data.
 *   3. `Offer.landingPage`, set on the offer when the drop is built (ServiceLayer
 *      app/refi/landingPages.js). This is the one that decides what most members see.
 *
 * Anything unrecognised falls through to `default`, never to an error.
 */

/** Reachable with `?t=`. Excludes `default` (which is the absence of a `t`) and the modes. */
export const ParamLandingPages = [
    'compact',
    'documents',
    'gclf',
    'gclf2',
    'me',
    'new',
    'paymentReduction',
    'rateReduction'
];

/**
 * Assignable to an offer. Must stay in step with `RefiLandingPages` in the ServiceLayer
 * (app/refi/landingPages.js), which is the mongoose enum that keeps a typo out of a mail
 * drop. Deliberately smaller than the list above: `documents`, `me` and `new` are not
 * offer pages at all, and `gclf`/`gclf2` are a finished experiment.
 */
export const AssignableLandingPages = [
    'compact',
    'default',
    'paymentReduction',
    'rateReduction'
];

/** How the member ended up on the page they are looking at. */
export const LandingPageSources = {
    ASSIGNED: 'assigned',
    DEFAULT: 'default',
    PARAM: 'param'
};

export const DefaultLandingPage = 'default';
